import { Image } from "antd-mobile";
import { HelpStep } from "../data";
import styles from "./index.module.scss";
import { useConfigContext } from "@/app";
type ProcessProps = {
  title: string;
  steps: HelpStep[];
};
export const Process = (props: ProcessProps) => {
  const {
    getSourcePath
  } = useConfigContext();
  return <div className={styles.step} data-sentry-component="Process" data-sentry-source-file="index.tsx">
      {props.steps.map((item: HelpStep, index: number) => {
      return <div key={`${props.title}-${item.title}`}>
            <div className={styles.stepTitle}>
              <div className={styles.stepTitleOrder}>
                {item.title ? index + 1 < 10 ? `0` + (index + 1) : index + 1 : null}
              </div>
              <div className={styles.stepTitleText}>{item.title}</div>
            </div>
            <div className={styles.stepContent}>
              <div className={styles.stepDesc}>{item.desc}</div>
              {item.img ? <img className={styles.stepImg} src={item.img} alt="" /> : null}
            </div>
          </div>;
    })}
    </div>;
};